export const FETCH_BUILDING_CODES = "FETCH_BUILDING_CODES";
export const FETCH_BUILDING_CODES_SUCCESS = "FETCH_BUILDING_CODES_SUCCESS";
export const FETCH_BUILDING_CODES_FAILURE = "FETCH_BUILDING_CODES_FAILURE";
